export default __webpack_public_path__ + "static/media/blog_image1.7be5f738.png";